import styled, { css } from 'styled-components';


export const OuterFooterPriceContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  margin-left: 25px;
  font-size: 25px;
`;

export const OuterFooterButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 50px;
  height: 50px;
  min-width: 50px;
  min-height: 50px;
  max-width: 50px;
  max-height: 50;
  font-size: 26px;
  cursor: pointer;

  background-color: white;

  margin-right: 25px;

  &:last-of-type {
    margin-right: 50px;
  }
`;

export const OuterFooterContainer = styled.div<{modelFullscreen:boolean, mobile:boolean, menuScaleFactor:number}>`
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 100px;

  /* Keep width in line with width of MenuContainer component*/
  width: 65%;
  max-width: calc(100% - 500px);
  min-width: calc(100% - 1000px); 

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;

  z-index: 13;

  ${(props) => props.modelFullscreen && css`
    width: 100%;
    max-width: 100%;

    & ${OuterFooterButtonContainer} {
      border: 1px solid black;
    };
  `};

  ${(props) => props.mobile && css`
    height: ${55 * props.menuScaleFactor}px;
    width: 100%;
    max-width: 100%;
    bottom: 50%;

    & ${OuterFooterPriceContainer} {
      height: ${50 * props.menuScaleFactor}px;
      font-size: ${25 * props.menuScaleFactor}px;
      margin-left: ${20 * props.menuScaleFactor}px;
    };

    & ${OuterFooterButtonContainer} {
      background-color: transparent;
      margin-right: ${20 * props.menuScaleFactor}px;
      width: ${30 * props.menuScaleFactor}px;
      min-width: ${30 * props.menuScaleFactor}px;
      height: ${50 * props.menuScaleFactor}px;
      min-height: ${50 * props.menuScaleFactor}px;
      font-size: ${26 * props.menuScaleFactor}px;
    };

    & ${OuterFooterButtonContainer}:last-of-type {
      margin-right: ${20 * props.menuScaleFactor}px;
    };
  `};

  ${(props) => props.mobile && props.modelFullscreen && css`
    bottom: 0px;

    & ${OuterFooterButtonContainer} {
      width: ${50 * props.menuScaleFactor}px;
      background-color: white;
    };

    & ${OuterFooterButtonContainer}:last-of-type {
      margin-right: ${5 * props.menuScaleFactor}px;
    };
  `};
`;